module.exports = __webpack_public_path__ + "static/jamie-ousby-68053b2271215cab072ae89917b6534b.jpg";